// extracted by mini-css-extract-plugin
export default {"title":"AnnouncementDetails_title__qAKe+","subTitle":"AnnouncementDetails_subTitle__AxPNj","description":"AnnouncementDetails_description__drmzd"};